export default __webpack_public_path__ + "static/media/007-fashion design.d016cdb5.svg";